import { Component, type ErrorInfo, type ReactNode } from 'react'

type ErrorBoundaryProps = {
  children: ReactNode
}

type ErrorBoundaryState = {
  message: string | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { message: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { message: error.message || 'Неизвестная ошибка' }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Mini app render error', error, info)
  }

  render() {
    if (this.state.message) {
      return (
        <main className="screen">
          <h1>Ошибка mini app</h1>
          <p className="lead">{this.state.message}</p>
          <p className="muted">Закройте и откройте приложение из бота снова.</p>
        </main>
      )
    }

    return this.props.children
  }
}
